import React from 'react'
import { Box, TextField } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

const DateRangePicker = (props: dateRangePickerProps) => {
  const { startDate, setStartDate, endDate, setEndDate, onDateChange } = props
  const handleStartDate = (value: Date | null) => {
    if (value) {
      setStartDate(value)
      onDateChange && onDateChange()
    }
  }

  const handleEndDate = (value: Date | null) => {
    if (value) {
      setEndDate(value)
      onDateChange && onDateChange()
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ display: 'flex', columnGap: '5px', alignItems: 'center' }}>
        <DesktopDatePicker
          label='Start Date'
          inputFormat='dd/MM/yyyy'
          value={startDate}
          maxDate={endDate}
          onChange={handleStartDate}
          renderInput={(params) => (
            <TextField
              placeholder='Start Date'
              {...params}
              sx={{
                '& .MuiOutlinedInput-input': {
                  padding: '11px 12px'
                }
              }}
            />
          )}
        />
        <DesktopDatePicker
          label='End Date'
          inputFormat='dd/MM/yyyy'
          value={endDate}
          onChange={handleEndDate}
          minDate={startDate}
          renderInput={(params) => (
            <TextField
              placeholder='End Date'
              {...params}
              sx={{
                '& .MuiOutlinedInput-input': {
                  padding: '11px 12px'
                }
              }}
            />
          )}
        />
      </Box>
    </LocalizationProvider>
  )
}

export default DateRangePicker

export interface dateRangePickerProps {
  startDate: Date
  setStartDate: React.Dispatch<React.SetStateAction<Date>>
  endDate: Date
  setEndDate: React.Dispatch<React.SetStateAction<Date>>
  onDateChange?: () => void
}
